import {observer} from "mobx-react";
import React from "react";
import {LocaleLabel} from "core/metamodel/metaDomain";
import {BlockComp} from "core/components/blockComp/blockComp";
import {loc} from "core/common/config/locales";
import {MdTextField} from "core/components/fields/fields";
import {fieldStyles} from "core/form/createForm";

interface LocalizeFieldIntf {
  fieldName: string;
  locArray: LocaleLabel[];
}

interface LocalizeFieldsProps {
  fields: LocalizeFieldIntf[];
}

@observer
export default class LocalizeFields extends React.Component<LocalizeFieldsProps, undefined> {

  handleLabelChange = (locLabel: LocaleLabel, event) => {
    locLabel.label = event.target.value;
  };

  render(): JSX.Element | false | null {

    return (
      <div>
        {
          this.props.fields.map(({fieldName, locArray}) => (
            <BlockComp key={fieldName} style={{marginTop: 10}} header={fieldName}>
              <table>
                <tbody>
                {
                  locArray.sort((a,b) => a.locale.localeCompare(b.locale)).map((locLabel) => (
                    <tr key={locLabel.locale}>
                      <td style={{padding: "0 10px"}} >{loc.get(locLabel.locale)}</td>
                      <td>
                        <MdTextField {...fieldStyles.small.textField} style={{height:40}} inputStyle={{marginTop: 0}}  name={fieldName} value={locLabel.label}
                                     disabled={locLabel.locale === loc.defaultLang} onChange={this.handleLabelChange.bind(this,locLabel)} />
                      </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
            </BlockComp>
          ))
        }
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/core/components/localization/localizeFields.tsx